import i18n from '@/i18n'

export function addTitleInToolbar () {
  const oToolBar = document.querySelector('.ql-toolbar')
  const aButton = oToolBar.querySelectorAll('button')
  const aSelect = oToolBar.querySelectorAll('select')
  aButton.forEach(function (item) {
    let i18nKey = item.classList[0]
    if (item.className === 'ql-script' || item.className === 'ql-indent') {
      i18nKey += `-${item.value}`
    }
    item.title = i18n.t(`quillEditor.toolbar.title.${i18nKey}`)
  })
  aSelect.forEach(function (item) {
    item.previousElementSibling.title = i18n.t(`quillEditor.toolbar.title.${item.classList[0]}`)
  })
}

export const microSiteCommonOption = {
  placeholder: '',
  modules: {
    toolbar: [
      [
        'bold',
        'italic',
        'underline',
        {
          color: []
        },
        {
          size: ['8px', '10px', '12px', '14px', '16px', '20px', '24px', '36px']
        },
        {
          align: []
        },
        {
          list: 'ordered'
        },
        {
          list: 'bullet'
        },
        'link'
      ],
      [
        'clean'
      ]
    ]
  }
}
